export default __webpack_public_path__ + "static/media/faq.93e99178.png";